<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	<lgb-back name="proxies-list"></lgb-back>
	<h1 class="my-4">Proxy</h1>
	<lgb-message [(msg)]="msg" [(error)]="error"></lgb-message>
	@if(proxy()){
		<fieldset class="fieldset border-base-300 rounded-box border p-4 glass">
	  		<legend class="fieldset-legend px-2">{{((isUpdate())? 'Modifier' : 'Ajouter')}} un proxy</legend>
			<form #values #form="ngForm">

				<!-- ref -->
				<label class="floating-label mb-4">
				  <span>Ref</span>
				  <input type="text" placeholder="Ref" name="ref" class="input input-md w-full" [(ngModel)]="proxy().ref" required />
				</label>

				<!-- Name -->
				<label class="floating-label mb-4">
				  <span>Name</span>
				  <input type="text" placeholder="Name" name="name" class="input input-md w-full" [(ngModel)]="proxy().name" required />
				</label>
				<div class="btn-container">
					<button (click)="setProxy()" class="btn btn-primary btn-gradient" [disabled]="form.invalid">Valider</button>
				</div>
			</form>
		</fieldset>
	}
</div>
